(function () {
  'use strict';

  // Offer-aware announcement slides (loaded by sections/header.liquid only when
  // an offer_announcement block is present). The bar is a COMPOSITION: hand-typed
  // slides carry always-true facts (shipping, returns); offer slides carry offer
  // claims, sourced from the offer metaobject's copy_locked - never typed.
  //
  // Two slide modes, matching the block's optional offer reference:
  //   [data-offer-announcement]  SESSION slide - server-rendered with the DEFAULT
  //     offer's copy (no flash), re-synced here to window.__sessionOffer (the
  //     layer that owns sitewide messaging) on every offer:resolved. A blackout
  //     landing or sticky session replaces the message with its own offer's copy.
  //     If NO session offer resolves (e.g. the default's window lapsed) or the
  //     session offer has no copy, the slide is REMOVED - a claim it cannot
  //     re-source truthfully must not stand.
  //   [data-offer-pinned="<id>"] PINNED slide - always advertises one offer
  //     (e.g. the set tiers, true for every session). Availability is the
  //     RESOLVER's rule (OfferResolver.availableTo: enabled + window +
  //     suppression + gift-exclusivity) - removed when it says no. This runs
  //     even with no session, so an expired pinned offer never lingers.
  //
  // Slick notes: the carousel counts DOM slides at init (fade mode, no clones),
  // so removal before init just works; after init we go through slickRemove.
  // After any removal the carousel may degrade below 2 slides - controls are
  // hidden (their handlers only bind for real carousels) and a lone slide's
  // autoplay is stopped; zero slides hides the bar.

  function findOffer(id) {
    var reg = window.OfferRegistry || [];
    for (var i = 0; i < reg.length; i++) if (reg[i].id === id) return reg[i];
    return null;
  }

  function degradeCarousel(container) {
    if (!container) return;
    var wrapper = container.closest('.cc-announcement--carousel-wrapper') || container;
    var slides = container.querySelectorAll('.cc-announcement__slide:not(.slick-cloned)');
    if (slides.length >= 2) return;
    var controls = wrapper.querySelector('.cc-announcement__controls');
    if (controls) controls.style.display = 'none';
    var $ = window.jQuery;
    if (slides.length === 1 && $ && $.fn && $.fn.slick && container.classList.contains('slick-initialized')) {
      $(container).slick('slickPause');
    }
    if (slides.length === 0) wrapper.style.display = 'none';
  }

  function removeSlide(el) {
    // single-block mode renders no __slide wrapper - fall back to the bar itself
    var slide = el.closest('.cc-announcement__slide') || el.closest('.cc-announcement');
    if (!slide) return;
    var container = slide.closest('.cc-announcement__carousel-container');
    if (container && container.classList.contains('slick-initialized') &&
        window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
      var $c = window.jQuery(container);
      var idx = $c.find('.cc-announcement__slide').index(slide);
      if (idx > -1) { $c.slick('slickRemove', idx); degradeCarousel(container); return; }
    }
    slide.remove();
    degradeCarousel(container);
  }

  function disarmLink(el, wrap) {
    if (!wrap.getAttribute('href')) return;
    el.setAttribute('data-offer-href', wrap.getAttribute('href'));
    wrap.removeAttribute('href');
    // theme.js's animate-click handler reads .attr('href') unguarded - a
    // disarmed anchor with the attribute still on throws on click
    if (wrap.hasAttribute('data-cc-animate-click')) {
      el.setAttribute('data-offer-animate', '1');
      wrap.removeAttribute('data-cc-animate-click');
    }
  }

  function rearmLink(el, wrap) {
    if (!el.hasAttribute('data-offer-href') || wrap.getAttribute('href')) return;
    wrap.setAttribute('href', el.getAttribute('data-offer-href'));
    if (el.hasAttribute('data-offer-animate')) wrap.setAttribute('data-cc-animate-click', '');
  }

  function apply() {
    var session = window.__sessionOffer || null;

    // PINNED slides first - their truth does not depend on a session existing.
    var R = window.OfferResolver;
    document.querySelectorAll('[data-offer-pinned]').forEach(function (el) {
      var offer = findOffer(el.getAttribute('data-offer-pinned'));
      var ok = R && typeof R.availableTo === 'function'
        ? R.availableTo(offer, session)
        : !!(offer && offer.enabled !== false);
      if (!ok) removeSlide(el);
    });

    // SESSION slide: speak the session offer's copy - or say nothing at all.
    var msg = '';
    if (session && session.copy) msg = (session.copy.locked || session.copy.unlocked || '').trim();
    document.querySelectorAll('[data-offer-announcement]').forEach(function (el) {
      if (!msg) { removeSlide(el); return; }
      if (el.textContent.trim() !== msg) el.textContent = msg;
      // The block's optional link is configured FOR the default offer; when a
      // different offer holds the session the link would lie - disarm it
      // (re-arm if the session returns to the default).
      var wrap = el.closest('a.cc-announcement__link');
      if (!wrap) return;
      if (el.getAttribute('data-offer-default') === session.id) rearmLink(el, wrap);
      else disarmLink(el, wrap);
    });
  }

  if (window.__offerAnnouncementBound) return; // editor section re-render guard
  window.__offerAnnouncementBound = true;
  document.addEventListener('offer:resolved', apply);
  if (window.__sessionOffer !== undefined) apply();
})();
